import {
  PROJECT_ON_BOARD_LOAD_POPULAR_EXTENSION_BEGIN,
  PROJECT_ON_BOARD_LOAD_POPULAR_EXTENSION_SUCCESS,
  PROJECT_ON_BOARD_LOAD_POPULAR_EXTENSION_FAILURE,
  PROJECT_ON_BOARD_LOAD_POPULAR_EXTENSION_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadPopularExtension(args = {}) {
  return (dispatch) => {
    dispatch({
      type: PROJECT_ON_BOARD_LOAD_POPULAR_EXTENSION_BEGIN,
    });

    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/extensions/popular`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: PROJECT_ON_BOARD_LOAD_POPULAR_EXTENSION_SUCCESS,
            data: res.data ? res.data : [],
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: PROJECT_ON_BOARD_LOAD_POPULAR_EXTENSION_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadPopularExtensionError() {
  return {
    type: PROJECT_ON_BOARD_LOAD_POPULAR_EXTENSION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PROJECT_ON_BOARD_LOAD_POPULAR_EXTENSION_BEGIN:
      return {
        ...state,
        loadPopularExtensionPending: true,
        loadPopularExtensionError: null,
      };

    case PROJECT_ON_BOARD_LOAD_POPULAR_EXTENSION_SUCCESS:
      return {
        ...state,
        loadPopularExtensionPending: false,
        loadPopularExtensionError: null,
        popularPlugins: action.data,
      };

    case PROJECT_ON_BOARD_LOAD_POPULAR_EXTENSION_FAILURE:
      return {
        ...state,
        loadPopularExtensionPending: false,
        loadPopularExtensionError: action.data.error,
      };

    case PROJECT_ON_BOARD_LOAD_POPULAR_EXTENSION_DISMISS_ERROR:
      return {
        ...state,
        loadPopularExtensionError: null,
      };

    default:
      return state;
  }
}
